import React, { useState } from "react";
import ExplanationOfBenefits from "./ExplanationOfBenefits";
import useQuery from "../../../../utils/hooks/useQuery";

const ExplanationIndex = () => {
	const query = useQuery();
	const [activeTab, setActiveTab] = useState("providerEOB");

	const renderTabContent = () => {
		switch (activeTab) {
			case "providerEOB":
				return <ExplanationOfBenefits query={query} />;
			case "employeeEOB":
				return <ExplanationOfBenefits query={query} />;

			default:
				return null;
		}
	};

	return (
		<div
			style={{
				paddingTop: "20px",
				marginTop: "40px",
				background: "#1f002d"
				// boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
			}}
		>
			<div
				style={{
					display: "flex",
					// marginBottom: "20px"
					marginLeft: "20px"
				}}
			>
				<TabButton
					label="Provider EOB"
					isActive={activeTab === "providerEOB"}
					onClick={() => setActiveTab("providerEOB")}
				/>
				<TabButton
					label="Employee EOB"
					isActive={activeTab === "employeeEOB"}
					onClick={() => setActiveTab("employeeEOB")}
				/>
			</div>
			<div>{renderTabContent()}</div>
		</div>
	);
};

type TabButtonProps = {
	label: string;
	isActive: boolean;
	onClick: () => void;
};

const TabButton: React.FC<TabButtonProps> = ({ label, isActive, onClick }) => {
	return (
		<button
			onClick={onClick}
			style={{
				padding: "10px 20px",
				marginRight: "10px",
				// borderRadius: "8px",
				borderTopRightRadius: "10px",
				// borderTopLeftRadius: "10px",
				border: "none",
				cursor: "pointer",
				fontSize: "16px",
				fontWeight: isActive ? "bold" : "normal",
				color: isActive ? "#000000ff" : "#ffffffff",
				background: isActive ? "#f5f5f5" : "transparent",
				boxShadow: isActive ? "0 4px 12px rgba(126, 34, 206, 0.3)" : "none",
				transition: "all 0.3s ease"
			}}
		>
			{label}
		</button>
	);
};

export default ExplanationIndex;
